import Icon from './components/Icon';

const IconCart = ({ ...props }: any) => {
	return <Icon handle={props.handle} id="hpa-cart" {...props} />;
};

export default IconCart;
